<template>
  <div class="">
    <!-- Show a single theme in a div -->
    <b>
    <v-layout row wrap>

        <v-flex class="" v-bind:style="{ 'backgroundColor': colors.background, 'color':fontColor }"  >background</v-flex>
        <v-flex class="" v-bind:style="{ 'backgroundColor': colors.primary, 'color':fontColor }"  >primary</v-flex>
        <v-flex class="" v-bind:style="{ 'backgroundColor': colors.secondary , 'color':fontColor}">secondary</v-flex>
        <v-flex class="" v-bind:style="{ 'backgroundColor': colors.accent , 'color':fontColor}">accent</v-flex>
        <!--
          <v-flex class="" v-bind:style="{ 'backgroundColor': colors.error , 'color':fontColor}">error</v-flex>
          <v-flex class="" v-bind:style="{ 'backgroundColor': colors.info , 'color':fontColor}">info</v-flex>
          <v-flex class="" v-bind:style="{ 'backgroundColor': colors.success , 'color':fontColor}">success</v-flex>
          <v-flex class="" v-bind:style="{ 'backgroundColor': colors.warning , 'color':fontColor}">warning</v-flex>
        -->

    </v-layout>
    </b>
</div>

</template>

<script>

import themes from '../../../themes.js'

export default {
  name: 'ThemeDisplay',
  components: {
  },
  props: ['themeNumber'],
  computed: {
    colors: function () {
      return themes.getTheme(this.themeNumber)
    },
    fontColor: function () {
      return themes.getFontColor(this.themeNumber)
      // if (themes.getFontColor(this.themeNumber)) {
      //   return '#FFFFFF'
      // } else {
      //   return '#000000'
      // }
      // // return themes.getFontColor(this.themeNumber)
    }
  },
  data () {
    return {

      inprogress: false,
      updateSuccess: false,
      errMessage: null
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
